module.exports = {"id":"207785","name":"Thabo Matlaba","rating":"74","photo":"./data/images/photos/3/207785.png","club":{"name":"Orlando Pirates","logo":"./data/images/clubs/OrlandoPirates.png"},"positions":["DG","DD","MG","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ThaboMatlaba0.json
// module id = 4087
// module chunks = 0